import { render, staticRenderFns } from "./BandeiraDinners.vue?vue&type=template&id=09172eab&"
import script from "./BandeiraDinners.vue?vue&type=script&lang=js&"
export * from "./BandeiraDinners.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports